<template>
  <v-app-bar
    absolute
    app
    color="transparent"
    flat
    height="75"
    style="width: auto;"
  >
    <v-btn
      fab
      small
      @click="$vuetify.breakpoint.smAndDown ? setDrawer(!drawer) : $emit('input', !value)"
    >
      <v-icon v-if="value">
        mdi-view-quilt
      </v-icon>

      <v-icon v-else>
        mdi-dots-vertical
      </v-icon>
    </v-btn>
    <v-spacer />
    <v-menu
      bottom
      right
      offset-y
      origin="top right"
      transition="scale-transition"
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          class="ml-2"
          min-width="0"
          text
          v-bind="attrs"
          v-on="on"
        >
          <v-badge
            v-if="filteredNotifications.length"
            color="red"
            overlap
            bordered
          >
            <template v-slot:badge>
              {{ filteredNotifications.length }}
            </template>

            <v-icon>mdi-bell</v-icon>
          </v-badge>
          <v-icon v-else>
            mdi-bell
          </v-icon>
        </v-btn>
      </template>

      <v-list
        :tile="false"
        nav
      >
        <app-bar-item
          v-for="(n, i) in filteredNotifications"
          :key="`item-${i}`"
        >
          <v-list-item-title
            @click="n.onClick(i)"
            v-text="n.msg"
          />
        </app-bar-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>

  // Utilities
  import { mapState, mapMutations } from 'vuex'
  import { VHover, VListItem } from 'vuetify/lib'

  import axios from 'axios'

  export default {
    name: 'DashboardCoreAppBar',
    components: {
      AppBarItem: {
        render (h) {
          return h(VHover, {
            scopedSlots: {
              default: ({ hover }) => {
                return h(VListItem, {
                  attrs: this.$attrs,
                  class: {
                    'black--text': !hover,
                    'white--text secondary elevation-12': hover,
                  },
                  props: {
                    activeClass: '',
                    dark: hover,
                    link: true,
                    ...this.$attrs,
                  },
                }, this.$slots.default)
              },
            },
          })
        },
      },
    },
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      hideNewUsers: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      cancelToken: null,
    }),
    computed: {
      ...mapState(['drawer', 'notifications']),
      filteredNotifications: function () {
        return this.hideNewUsers ? this.$_.reject(this.notifications, ['key', 'new_users']) : this.notifications
      },
    },
    watch: {

    },
    created: function () {
      if (!this.hideNewUsers) { this.checkForInactiveUser() }
    },
    methods: {
      ...mapMutations({
        setDrawer: 'SET_DRAWER',
        addNotication: 'ADD_NOTIFICATION',
        removeNotification: 'REMOVE_NOTIFICATION',
      }),
      checkForInactiveUser: function () {
        if (this.cancelToken) { this.cancelToken.cancel('cancelled') }
        this.cancelToken = axios.CancelToken.source()

        /* this.$get('/users?limit=10&page=1&filters%5Bactive%5D%5B%5D=0&q=', { cancelToken: this.cancelToken.token })
          .then(({ data }) => {
            if (data.total) {
              this.addNotication({
                key: 'new_users',
                msg: this.$t('new_inactive_users'),
                onClick: (index) => {
                  this.removeNotification(index)

                  this.$router.push('/users?limit=10&page=1&filters%5Bactive%5D%5B%5D=0&q=').catch(e => console.log(e))
                },
              })
            }
          }) */
      },
    },
  }
</script>
